const constants = {
  METAMASK_GAS_LIMIT_ASSOCIATE: 800_000,
  METAMASK_GAS_LIMIT_TRANSFER_FT: 50_000,
  METAMASK_GAS_LIMIT_TRANSFER_NFT: 100_000,
};

export type NetworkName = "testnet" | "mainnet";
export type ChainId = "0x128" | "0x127";

type NetworkConfigs = {
  [key in NetworkName]: {
    network: NetworkName;
    jsonRpcUrl: string;
    mirrorNodeUrl: string;
    chainId: ChainId;
  };
};

type AppConfig = {
  networks: NetworkConfigs;
};

export const hederaNetworkConfig: NetworkConfigs = {
  testnet: {
    network: "testnet",
    jsonRpcUrl: "https://testnet.hashio.io/api", // check out the readme for alternative RPC Relay urls
    mirrorNodeUrl: "https://testnet.mirrornode.hedera.com",
    chainId: "0x128",
  },
  mainnet: {
    network: "mainnet",
    jsonRpcUrl: "https://mainnet.hashio.io/api", // check out the readme for alternative RPC Relay urls
    mirrorNodeUrl: "https://mainnet.mirrornode.hedera.com",
    chainId: "0x127",
  },
};

export const hederaAppConfig: AppConfig & {
  constants: typeof constants;
} = {
  networks: hederaNetworkConfig,
  constants,
};
